export const playerEventsParams = [
  {
    actions: [
      {
        id: 14,
        lexic_id: 326,
        title: 'On-Ball Events',
      },
      {
        id: 15,
        lexic_id: 550,
        title: 'On-Ball Events +',
      },
      {
        id: 17,
        lexic_id: 552,
        title: 'On-Ball Events -',
      },
      {
        id: 19,
        lexic_id: 328,
        title: 'Fouls',
      },
      {
        id: 20,
        lexic_id: 554,
        title: 'Fouls Suffered',
      },
      {
        id: 21,
        lexic_id: 104,
        title: 'Yellow Cards',
      },
      {
        id: 22,
        lexic_id: 555,
        title: 'Yellow-Red Cards',
      },
      {
        id: 23,
        lexic_id: 103,
        title: 'Red Cards',
      },
      {
        id: 163,
        lexic_id: 333,
        title: 'Offsides',
      },
      {
        id: 161,
        lexic_id: 324,
        title: 'Goal Mistakes',
      },
      {
        id: 162,
        lexic_id: 556,
        title: 'Grave Mistakes',
      },
    ],
    id: 1,
    lexic_id: 549,
    title: 'General',
  },
  {
    actions: [
      {
        id: 2,
        lexic_id: 558,
        title: 'Goals +',
      },
      {
        id: 3,
        lexic_id: 768,
        title: 'Penalty goals +',
      },
      {
        id: 4,
        lexic_id: 560,
        title: 'Goal Scoring Opportunities',
      },
      {
        id: 5,
        lexic_id: 561,
        title: 'Goal Scoring Opportunities +',
      },
      {
        id: 7,
        lexic_id: 563,
        title: 'Goal Scoring Opportunities -',
      },
      {
        id: 9,
        lexic_id: 766,
        title: 'Goal Scoring Opportunities Allowed',
      },
      {
        id: 10,
        lexic_id: 767,
        title: 'Goal Scoring Opportunities Allowed +',
      },
      {
        id: 12,
        lexic_id: 768,
        title: 'Goal Scoring Opportunities Allowed -',
      },
      {
        id: 24,
        lexic_id: 18,
        title: 'Shots',
      },
      {
        id: 25,
        lexic_id: 462,
        title: 'Shots on Target',
      },
      {
        id: 27,
        lexic_id: 570,
        title: 'Shots Wide',
      },
      {
        id: 29,
        lexic_id: 572,
        title: 'Shots Blocked',
      },
      {
        id: 31,
        lexic_id: 574,
        title: 'Shots on Post or Bar',
      },
      {
        id: 33,
        lexic_id: 576,
        title: 'Shots from Free kick',
      },
    ],
    id: 2,
    lexic_id: 557,
    title: 'Goals/Chances/Shots',
  },
  {
    actions: [
      {
        id: 35,
        lexic_id: 19,
        title: 'Passes',
      },
      {
        id: 36,
        lexic_id: 578,
        title: 'Passes +',
      },
      {
        id: 38,
        lexic_id: 580,
        title: 'Passes -',
      },
      {
        id: 40,
        lexic_id: 722,
        title: 'Passes into duel',
      },
      {
        id: 41,
        lexic_id: 723,
        title: 'Passes into duel +',
      },
      {
        id: 43,
        lexic_id: 724,
        title: 'Passes into duel -',
      },
      {
        id: 50,
        lexic_id: 587,
        title: 'Crosses',
      },
      {
        id: 51,
        lexic_id: 588,
        title: 'Crosses +',
      },
      {
        id: 53,
        lexic_id: 590,
        title: 'Crosses -',
      },
      {
        id: 90,
        lexic_id: 592,
        title: 'Passes Recieved',
      },
      {
        id: 91,
        lexic_id: 593,
        title: 'Passes into duel Received',
      },
      {
        id: 95,
        lexic_id: 595,
        title: 'Crosses Received',
      },
    ],
    id: 3,
    lexic_id: 19,
    title: 'Passes',
  },
  {
    actions: [
      {
        id: 55,
        lexic_id: 664,
        title: 'Short Passes',
      },
      {
        id: 56,
        lexic_id: 665,
        title: 'Short Passes +',
      },
      {
        id: 58,
        lexic_id: 667,
        title: 'Short Passes -',
      },
      {
        id: 60,
        lexic_id: 669,
        title: 'Medium Passes',
      },
      {
        id: 61,
        lexic_id: 670,
        title: 'Medium Passes +',
      },
      {
        id: 63,
        lexic_id: 672,
        title: 'Medium Passes -',
      },
      {
        id: 65,
        lexic_id: 674,
        title: 'Long Passes',
      },
      {
        id: 66,
        lexic_id: 675,
        title: 'Long Passes +',
      },
      {
        id: 68,
        lexic_id: 677,
        title: 'Long Passes -',
      },
      {
        id: 97,
        lexic_id: 679,
        title: 'Short Passes Received',
      },
      {
        id: 99,
        lexic_id: 681,
        title: 'Medium Passes Received',
      },
      {
        id: 101,
        lexic_id: 683,
        title: 'Long Passes Received',
      },
    ],
    id: 4,
    lexic_id: 663,
    title: 'Passes by distance',
  },
  {
    actions: [
      {
        id: 70,
        lexic_id: 685,
        title: 'Passes Onward',
      },
      {
        id: 71,
        lexic_id: 686,
        title: 'Passes Onward +',
      },
      {
        id: 73,
        lexic_id: 688,
        title: 'Passes Onward -',
      },
      {
        id: 75,
        lexic_id: 690,
        title: 'Passes Rearward',
      },
      {
        id: 76,
        lexic_id: 691,
        title: 'Passes Rearward +',
      },
      {
        id: 78,
        lexic_id: 693,
        title: 'Passes Rearward -',
      },
      {
        id: 80,
        lexic_id: 695,
        title: 'Passes Sideways',
      },
      {
        id: 81,
        lexic_id: 696,
        title: 'Passes Sideways +',
      },
      {
        id: 83,
        lexic_id: 698,
        title: 'Passes Sideways -',
      },
      {
        id: 103,
        lexic_id: 700,
        title: 'Passes Onward Received',
      },
      {
        id: 105,
        lexic_id: 702,
        title: 'Passes Rearward Received',
      },
      {
        id: 107,
        lexic_id: 704,
        title: 'Passes Sideways Received',
      },
    ],
    id: 5,
    lexic_id: 706,
    title: 'Passes by side',
  },
  {
    actions: [
      {
        id: 201,
        lexic_id: 105,
        title: 'Assists',
      },
      {
        id: 45,
        lexic_id: 330,
        title: 'Key Passes',
      },
      {
        id: 46,
        lexic_id: 598,
        title: 'Key Passes +',
      },
      {
        id: 48,
        lexic_id: 600,
        title: 'Key Passes -',
      },
      {
        id: 85,
        lexic_id: 602,
        title: 'Progressive Passes',
      },
      {
        id: 86,
        lexic_id: 603,
        title: 'Progressive Passes +',
      },
      {
        id: 88,
        lexic_id: 605,
        title: 'Progressive Passes -',
      },
      {
        id: 93,
        lexic_id: 607,
        title: 'Key Passes Received',
      },
      {
        id: 109,
        lexic_id: 609,
        title: 'Progressive Passes Received',
      },
    ],
    id: 6,
    lexic_id: 597,
    title: 'Advanced passes',
  },
  {
    actions: [
      {
        id: 122,
        lexic_id: 20,
        title: 'Duels',
      },
      {
        id: 123,
        lexic_id: 611,
        title: 'Duels +',
      },
      {
        id: 125,
        lexic_id: 613,
        title: 'Duels -',
      },
      {
        id: 127,
        lexic_id: 331,
        title: 'Aerial Duels',
      },
      {
        id: 128,
        lexic_id: 615,
        title: 'Aerial Duels +',
      },
      {
        id: 130,
        lexic_id: 617,
        title: 'Aerial Duels -',
      },
      {
        id: 132,
        lexic_id: 619,
        title: 'Duels in Offence',
      },
      {
        id: 133,
        lexic_id: 620,
        title: 'Duels in Offence +',
      },
      {
        id: 135,
        lexic_id: 622,
        title: 'Duels in Offence -',
      },
      {
        id: 137,
        lexic_id: 624,
        title: 'Duels in Defence',
      },
      {
        id: 138,
        lexic_id: 625,
        title: 'Duels in Defence +',
      },
      {
        id: 140,
        lexic_id: 627,
        title: 'Duels in Defence -',
      },
    ],
    id: 7,
    lexic_id: 20,
    title: 'Duels',
  },
  {
    actions: [
      {
        id: 142,
        lexic_id: 630,
        title: 'Tackles Made',
      },
      {
        id: 143,
        lexic_id: 631,
        title: 'Tackles Made +',
      },
      {
        id: 145,
        lexic_id: 633,
        title: 'Tackles Made -',
      },
      {
        id: 152,
        lexic_id: 635,
        title: 'Interceptions',
      },
      {
        id: 153,
        lexic_id: 636,
        title: 'Interceptions +',
      },
      {
        id: 155,
        lexic_id: 638,
        title: 'Interceptions -',
      },
      {
        id: 157,
        lexic_id: 640,
        title: 'Blocked shots',
      },
      {
        id: 160,
        lexic_id: 641,
        title: 'Clearances',
      },
      {
        id: 117,
        lexic_id: 642,
        title: 'Dribbles Faced',
      },
      {
        id: 118,
        lexic_id: 643,
        title: 'Dribbles Faced +',
      },
      {
        id: 120,
        lexic_id: 645,
        title: 'Dribbles Faced -',
      },
    ],
    id: 8,
    lexic_id: 629,
    title: 'In defence',
  },
  {
    actions: [
      {
        id: 112,
        lexic_id: 648,
        title: 'Dribbles Made',
      },
      {
        id: 113,
        lexic_id: 649,
        title: 'Dribbles Made +',
      },
      {
        id: 115,
        lexic_id: 651,
        title: 'Dribbles Made -',
      },
      {
        id: 111,
        lexic_id: 653,
        title: 'Progressive Carries',
      },
      {
        id: 147,
        lexic_id: 654,
        title: 'Tackles Faced',
      },
      {
        id: 148,
        lexic_id: 655,
        title: 'Tackles Faced +',
      },
      {
        id: 150,
        lexic_id: 657,
        title: 'Tackles Faced -',
      },
    ],
    id: 10,
    lexic_id: 647,
    title: 'In offence',
  },
  {
    actions: [
      {
        id: 158,
        lexic_id: 337,
        title: 'Ball Recoveries',
      },
      {
        id: 159,
        lexic_id: 336,
        title: 'Ball Losses',
      },
    ],
    id: 11,
    lexic_id: 431,
    title: 'Ball possession',
  },
];

